// 2j: Sitzungskennung = ein Browser-Tab (sessionStorage). Der Server waehlt daraus Schluss-Fassung und Staffelung.
export const sitzungsKennung = () => {
  let id = sessionStorage.getItem("f4s_sitzung");
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`).replace(/[^a-zA-Z0-9-]/g, "").slice(0, 64);
    sessionStorage.setItem("f4s_sitzung", id);
  }
  return id;
};
